import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Alert } from '@mui/material';
import { UserContext } from '../contexts/UserContext';
import { auth } from '../api/client';

export default function RegisterPage() {
  const { login } = useContext(UserContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleRegister = (e) => {
    e.preventDefault();
    setError('');
    auth.register({ username, password })
      .then(({ data }) => {
        setSuccess(true);
        login(data.user, data.access_token);
        setTimeout(() => navigate('/'), 1200);
      })
      .catch(err => setError(err.response?.data?.error || 'Registration failed'));
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 6 }}>
      <Typography variant="h4" gutterBottom>Register</Typography>
      <form onSubmit={handleRegister}>
        <TextField fullWidth label="Username" value={username} onChange={(e) => setUsername(e.target.value)} margin="normal" />
        <TextField fullWidth type="password" label="Password" value={password} onChange={(e) => setPassword(e.target.value)} margin="normal" />
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mt: 2 }}>Registered! Taking you to the modules...</Alert>}
        <Button variant="contained" type="submit" sx={{ mt: 2 }}>Register</Button>
      </form>
    </Box>
  );
}
